var map = {
	"./alien.svg": "e880",
	"./bear.svg": "e131",
	"./bunny.svg": "1111",
	"./fox.svg": "7fbb",
	"./frog.svg": "a8ca",
	"./monkey.svg": "e59f",
	"./owl.svg": "4826",
	"./robot.svg": "0110"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac43";